import { render, staticRenderFns } from "./StyledGoogleAutocomplete.vue?vue&type=template&id=12655d50"
import script from "./StyledGoogleAutocomplete.vue?vue&type=script&lang=ts"
export * from "./StyledGoogleAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports